import { Component, Input, OnInit } from '@angular/core';
import { SharedUtils } from '../../utilities/shared-utils';

@Component({
  selector: 'app-offcanvas',
  templateUrl: './offcanvas.component.html',
  styleUrls: ['./offcanvas.component.scss']
})
export class OffcanvasComponent implements OnInit {

    @Input('offCanvasHeaderLabel')
    headerLabel: string = "";

    constructor() { }

    ngOnInit(): void {
        if ( SharedUtils.inputValueIsEmpty(this.headerLabel) ) {
            this.headerLabel = "";
        }
    }
}
